import request from '../index'
import api from '../api'
import config from '../config'
const { env } = config
const needMock = true && env === 'LOCAL'
const mockData = ISDEVELOPMENT ? require('../mockData') : ''

// import config from '../config'
// const { env } = config

// export function getH5Config () {
//   const url = '/static/cnt/ui/h5/manifest.json'
//   return request(url, {
//     needEncrypt: true,
//     needXsign: true
//   })
// }

// export function getMyCard (clientId = '100469') {
//   const url = `/v1/mma/connect/clients/${clientId}/card`
//   return request(url, {
//     needEncrypt: true,
//     needXsign: true
//   })
// }

// MPF 卡片列表
export function getMPFCardList (mpfaccountid, acctid) {
  const url = `/v1/mma/connect/clients/${acctid}/accounts/${mpfaccountid}/card`
  return request(url, {
    needEncrypt: true,
    needXsign: true
  })
}

// EB 就诊类别查询
export function getEBProdList (uin, acctid) {
  const url = `/v1/mma/connect/users/${uin}/eb/${acctid}/prod`
  if (needMock) {
    return mockData.getEBProdList.data
  }
  return request(url, {
    needEncrypt: false,
    needXsign: false
  })
}

// EB 就诊人查询
export function getEBClaimmenbers (uin, acctid, func) {
  // const url = `/v1/mma/connect/users/${uin}/eb/${acctid}/policydetail`
  const url = `/v1/mma/connect/users/${uin}/eb/${acctid}/claimmenbers?function=${func}`
  if (needMock) {
    return mockData.getEBClaimmenbers.data
  }
  return request(url, {
    needEncrypt: false,
    needXsign: false
  })
}

// EB 保单最大理赔金额查询
export function getMaxClaimlLimit (uin, acctid, prodid = '', clientid = '') {
  let url = `/v1/mma/connect/users/${uin}/eb/${acctid}/maxclaimlimit`
  if (prodid || clientid) {
    url += `?prodid=${prodid}&clientid=${clientid}`
  }
  if (needMock) {
    if (prodid === 'HOSP') {
      return mockData.getMaxClaimlLimitHOSP.data
    } else {
      return mockData.getMaxClaimlLimitOUTP.data
    }
  }
  return request(url, {
    needEncrypt: false,
    needXsign: false
  })
}

// EB 电子理赔详情
export function getEBClaimDetail (uin, acctid, refno) {
  const url = `/v1/mma/connect/users/${uin}/eb/${acctid}/eclaim/${refno}`
  if (needMock) {
    return mockData.getEBClaimDetail.data
  }
  return request(url, {
    needEncrypt: false,
    needXsign: false
  })
}

// EB 索偿记录
export function getEBClaimHistory (data, uin, acctid) {
  const url = `/v1/mma/connect/users/${uin}/eb/${acctid}/claimrecords`
  return request(url, {
    method: 'POST',
    data,
    needEncrypt: false,
    needXsign: false
  })
}

// EB 理赔申请提交
export function submitEBClaimmenbers (uin, acctid, claims) {
  const url = `/v1/mma/connect/users/${uin}/eb/${acctid}/eclaim`
  return request(url, {
    method: 'POST',
    data: { claims },
    needEncrypt: false,
    needXsign: false
  })
}

// 文件上传
export function imgUpload (body, categoryid = 'policy') {
  let url = api.uploadFiles
  url = url
    .replace('{oid}', categoryid)
  return request(url, {
    method: 'POST',
    'content-type': 'application/octet-stream',
    data: body,
    needEncrypt: false,
    needXsign: false
  })
}

// 图片下载
export function imgDownload (categoryid, oid) {
  let url = api.imageDownload
  url = url
    .replace('{oid}', oid)
    .replace('{categoryid}', categoryid)
  return request(url, {
    needEncrypt: false,
    needXsign: false
  })
}

// 获取电子理赔声明url
export function getEclaimtncUrl (uin, acctid) {
  let url = api.getEclaimtncUrl
  url = url
    .replace('{uin}', uin)
    .replace('{acctid}', acctid)
  return request(url, {
    needEncrypt: false,
    needXsign: false
  })
}

export function getClaimApplicationRecord (query, uin, acctid) {
  if (needMock) {
    return mockData.getClaimApplicationRecord.data
  }

  const url = api.getClaimApplicationRecord
    .replace('{uin}', uin)
    .replace('{acctid}', acctid)
  // .replace('{start}', query.start)
  // .replace('{count}', query.count)

  // // 搜索项处理（没有选，则不传）
  // const arr = ['startdate', 'enddate', 'clientid', 'order']
  // for (const item of arr) {
  //   if (query[item] === void 0 || query[item] === '') {
  //     const temp = `&${item}={${item}}`
  //     url = url.replace(temp, '')
  //   } else {
  //     url = url.replace(`{${item}}`, query[item])
  //   }
  // }

  return request(url, {
    method: 'POST',
    data: query,
    needEncrypt: false,
    needXsign: false
  })
}
